import { MetadataService, PortfolioService } from '@amzn/awscat-portfolio-assessment-service-client';
import { AssessmentMetadata, Portfolio } from '@amzn/awscat-portfolio-assessment-types';
import { ButtonDropdownProps } from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';

const portfolioService = new PortfolioService();
const metadataService = new MetadataService();
export const noRecentPortfolios:ButtonDropdownProps.ItemGroup = {text: constants.NO_RECENT_PORTFOLIOS, id: 'noPortfolio', items: []};
export const viewAllPortfolios: ButtonDropdownProps.Item = {text: constants.VIEW_ALL_PORTFOLIOS, id: 'viewAll', href: '/portfolios'};
 
export const getDropDownContent = async (recentPortfolioIds: string[]): Promise<Array<ButtonDropdownProps.ItemOrGroup>> => {
    if (!recentPortfolioIds || recentPortfolioIds.length === 0) {
        return Promise.resolve([noRecentPortfolios, viewAllPortfolios]);
    }

    const recentPortfolios: Portfolio[] = await portfolioService.listPortfolios(recentPortfolioIds);
    if (!recentPortfolios || recentPortfolios.length === 0) {
        return Promise.resolve([noRecentPortfolios, viewAllPortfolios]);
    }

    const sortPortfolios = (portfolioA: Portfolio, portfolioB: Portfolio): number => {
        return recentPortfolioIds.indexOf(portfolioA.id) - recentPortfolioIds.indexOf(portfolioB.id);
    };
    // order portfolios to match storage so portfolios are shown by how recently they have been visited
    recentPortfolios.sort(sortPortfolios);

    // pull out all the TCO assessment ids
    const assessmentIds: string[] = [];
    recentPortfolios.forEach((portfolio: Portfolio) => {
        if (portfolio.tcoAssessmentIds) {
            portfolio.tcoAssessmentIds.forEach((id: string) => {
                assessmentIds.push(id);
            });
        }
    });
    const assessments: AssessmentMetadata[] = await metadataService.getList(assessmentIds);

    //For each portfolio id, create dropdown item
    const portfolioItems: Array<ButtonDropdownProps.ItemOrGroup> = [];
    recentPortfolios.forEach( (portfolio: Portfolio) => {
        try {
            const itemArray: Array<ButtonDropdownProps.ItemOrGroup> = [{
                id: portfolio.id,
                text: constants.ASSETS,
                href: `/portfolio/${portfolio.id}/management/assets/servers`
            }];

            if (portfolio.tcoAssessmentIds) {
                portfolio.tcoAssessmentIds.forEach(async (id: string) => {
                    const assessment: AssessmentMetadata | undefined =  assessments.find((metadata: AssessmentMetadata) => metadata.id === id);
                    if (assessment) {
                        const assessmentGroup: ButtonDropdownProps.ItemOrGroup = {
                            id: assessment.id,
                            text: assessment.name,
                            href: `/portfolio/${portfolio.id}/tco/${assessment.id}/summary`,
                        };
                        itemArray.push(assessmentGroup);
                    }
                });
            }

            const group: ButtonDropdownProps.ItemOrGroup = {
                text: portfolio.name,
                items: itemArray,
            };
            return portfolioItems.push(group);
        } catch (err) {
            console.log(err);
            return [];
        }
    });
    portfolioItems.push(viewAllPortfolios);
    return portfolioItems;
};
